import { createFileRoute, Navigate } from '@tanstack/react-router';
import { Authenticated, Unauthenticated } from 'convex/react';

const RootRedirectPage = () => {
  return (
    <>
      {/* Authenticated users go to dashboard (which redirects to role-specific dashboard) */}
      <Authenticated>
        <Navigate to='/dashboard' replace />
      </Authenticated>
      {/* Unauthenticated users go to sign-in */}
      <Unauthenticated>
        <Navigate to='/auth/sign-in' replace />
      </Unauthenticated>
    </>
  );
};

export const Route = createFileRoute('/')({
  component: RootRedirectPage,
});
